import React from 'react';
import styled, { css } from 'styled-components/macro';
import Header from '../containers/Header';
import { useTranslate } from '../contexts/languageContext';
import { usePage } from '../contexts/pageContext';

const LayoutResultados = ({ children, nomenclator }) => {
  const t = useTranslate();
  const pageState = usePage();
  const { data, urlInfo } = pageState;
  const { id, eleccion, page, idHistorico } = urlInfo;
  const esHistorico = idHistorico != null;
  const ambito = nomenclator.ambitos[eleccion][id];
  const nombreEleccion = nomenclator.nomAmbitos[eleccion].n;
  const nomAmbitos = nomenclator.nomAmbitos[eleccion];
  const primerColor = esHistorico ? '#646464' : '#1C283D';
  const segundoColor = esHistorico ? '#EDEDED' : nomAmbitos.cs;
  //const title = getTitle(id, eleccion, nomenclator, page, t, idHistorico);
  return (
    <Layout primerColor={primerColor} segundoColor={segundoColor}>
      <Header
        variant={'resultados'}
        esHistorico={esHistorico}
        nomenclator={nomenclator}
        ambito={ambito}
        data={data}
        {...urlInfo}
      >
        {!esHistorico ? (
          <p>{nombreEleccion}</p>
        ) : (
          <>
            <p>
              {page}
              <span css="font-size: 15px; font-weight: 100; margin-left: 15px">
                ({data.tope === '1' ? t('boletinAnterior') : t('avanceAnterior')})
              </span>
            </p>
          </>
        )}
      </Header>
      {children}
    </Layout>
  );
};

const Layout = styled(({ primerColor, segundoColor, ...rest }) => (
  <div {...rest} />
))`
  background: linear-gradient(
    to bottom, 
    ${({ primerColor }) => primerColor},
    ${({ primerColor }) => primerColor} 179px,
    #fff 179px,
    #fff 100%
  );

  
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export default LayoutResultados;
